(function () {
  var OFFSET_PROPERTY = '--c_gallery_offset';

  if (window.c_mwam_gallery_scroll_ready) {
    return;
  }
  window.c_mwam_gallery_scroll_ready = true;

  var root = document.querySelector('.c_mwam_message_gallery');
  var gallery = root && root.querySelector('.c_mwam_message_gallery__gallery');
  var track = gallery && gallery.querySelector('.c_mwam_message_gallery__track');

  if (!track) {
    return;
  }

  var desktop = window.matchMedia('(min-width: 750px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var startY = 0;
  var rangeY = 1;
  var distance = 0;
  var ticking = false;

  function measure() {
    track.style.removeProperty(OFFSET_PROPERTY);

    var rect = root.getBoundingClientRect();
    var box = window.getComputedStyle(gallery);
    var windowHeight = gallery.clientHeight
      - parseFloat(box.paddingTop)
      - parseFloat(box.paddingBottom);

    startY = rect.top + window.scrollY;
    rangeY = Math.max(1, rect.height - window.innerHeight);
    distance = Math.max(0, track.scrollHeight - windowHeight);

    update();
  }

  function update() {
    if (!desktop.matches || reduced.matches) {
      track.style.removeProperty(OFFSET_PROPERTY);
      return;
    }

    var progress = (window.scrollY - startY) / rangeY;
    progress = Math.min(1, Math.max(0, progress));
    track.style.setProperty(OFFSET_PROPERTY, -(progress * distance) + 'px');
  }

  function onScroll() {
    if (ticking) {
      return;
    }
    ticking = true;
    window.requestAnimationFrame(function () {
      ticking = false;
      update();
    });
  }

  var resizeTimer = 0;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(measure, 150);
  }

  measure();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
  window.addEventListener('load', measure);
  document.addEventListener('shopify:section:load', measure);
})();
